export const Assistance = () => {
  return <div></div>;
};
